import { z } from "zod"

export const UserSchema = z.object({
  id: z.number(),
  email: z.string(),
  name: z.string(),
  picture_url: z.string(),
})

export type User = z.infer<typeof UserSchema>
